<template>
  <div class="container mt-5 p-3">
    <!-- <div class="row">
      <div class="col">
        <i
          class="bi bi-person float-end text-primary fw-bold"
          @click="toggleUser()"
        ></i>
      </div>
    </div> -->
    <!-- <AuctioneerLogin v-if="view == 'auctioneer'"></AuctioneerLogin> -->
    <GoogleLogin v-if="view == 'user'"></GoogleLogin>
    <!-- <UserLogin v-if="view == 'user'"></UserLogin> -->
    <div
      class="position-absolute bottom-0 start-50 translate-middle-x mb-2 smalltxt"
    >
      v<span class="text-muted smalltxt">{{ version }}</span>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import AuctioneerLogin from "../components/login/AuctioneerLogin.vue";
import { version } from "@/version";
import UserLogin from "../components/login/UserLogin.vue";
import GoogleLogin from "../components/login/GoogleLogin.vue";
const view = ref("user");
const toggleUser = () => {
  if (view.value == "user") {
    view.value = "auctioneer";
  } else {
    view.value = "user";
  }
};
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.container {
  height: 100vh;
}
.smalltxt {
  font-size: 12px;
}
.my-container {
  background: linear-gradient(to bottom, #fcfcfc, #fafafa);
}
</style>
